import React from 'react'
import { useTheme } from '@mui/material/styles'
import {
  CloudDropdownButton,
  CloudOption,
  VerticalDivider,
} from '@labrav/react-components'
import { useStyles } from './CloudAccountWrapper.styles'
import { CloudSettingsHelpSections } from '../../FlyOutOnboardingWrapper/FlyOutMicrosoftCloudSettings/CloudSettingsHelpSections/CloudSettingsHelpSections'
import { marketplaceCloudAccountFaqContent } from '../CloudAccountFaqData'
import { CloudAccountLayout } from '../CloudAccountLayout'

export interface CloudAccountWrapperProps {
  title: string
  onCloudSelect: (option: CloudOption) => void
  cloudOptions: CloudOption[]
  ContentComponent: React.FC
}

const CloudAccountWrapper: React.FC<CloudAccountWrapperProps> = ({
  title,
  onCloudSelect,
  cloudOptions,
  ContentComponent,
}) => {
  const { classes } = useStyles()
  const theme = useTheme()

  return (
    <div className={classes.root} data-testid="cloud-account-wrapper">
      <CloudAccountLayout
        title={<div className={classes.title}>{title}</div>}
        component={ContentComponent}
        actions={() => (
          <div className={classes.actionsContainer}>
            <CloudSettingsHelpSections
              content={marketplaceCloudAccountFaqContent}
            />
            <VerticalDivider height={'40px'} />
            <CloudDropdownButton
              buttonText={'Add new cloud account'}
              disabled={false}
              cloudOptions={cloudOptions}
              onCloudSelect={onCloudSelect}
              menuWidth={80}
            />
          </div>
        )}
        paddingZero
        bgColor={theme.palette.labraV2BoxShadow.dark}
      />
    </div>
  )
}

export default CloudAccountWrapper
